// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./alerts"
import "./package_form_validation"

import $ from "jquery"
window.$ = $
window.jQuery = $
globalThis.$ = $
globalThis.jQuery = $

// Cocoon precisa do jQuery global no momento da avaliação
import("@nathanvda/cocoon")
